import {
	VehicleCategoryFeatureItemDto,
	VehicleFeatureItemDto,
} from '@splitsecondconnect/ultramarine-shared';
import { FeatureItemModel } from '../models/feature-item.model';

export function mapFeatureItemDtoToFeatureItemModel(
	x: VehicleFeatureItemDto[] | VehicleCategoryFeatureItemDto[],
): {
	featureItems: FeatureItemModel[];
} {
	if (!x) {
		return {
			featureItems: null,
		};
	}

	const featureItems: FeatureItemModel[] = [];

	x.forEach((item) => {
		featureItems.push({
			id: item.id,
			uuid: item.uuid,
			title: item.title,
			key: item.key,
		});
	});

	return { featureItems: featureItems };
}
